<script>
    export default {
        name: "Sidebar",
        props: {
            active: Number
        },
        mounted () {
        },
        methods: {
            isActive(number) {
                if (number == this.active) {
                    return true
                } else {
                    return false
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .btn-link {
        color: black;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/Sidebar.vue